// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"b51e9bd8","513":"9abde3b3","703":"d2f329a8","787":"7f424629"}[chunkId] + ".chunk.js";
};